import { useEffect } from 'react'
import { chatApi } from '@/api'

// Independent of selected session, search and pagination; never marks messages read.
export function useChatAlerts(enabled: boolean, onAlert: (count: number) => void) {
  useEffect(() => {
    if (!enabled) return
    let stopped = false
    let cursor: string | undefined
    let timer: ReturnType<typeof setTimeout>
    const poll = async () => {
      try {
        const result = await chatApi.alerts(cursor)
        if (stopped) return
        if (cursor !== undefined && result.list?.length) onAlert(result.list.length)
        cursor = result.cursor
      } catch { /* Retry without losing the cursor. */ }
      if (!stopped) timer = setTimeout(poll, 5000)
    }
    void poll()
    return () => { stopped = true; clearTimeout(timer) }
  }, [enabled, onAlert])
}
